import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function M() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2max.detail');
    const [isEnter, setIsEnter] = useState(false);

    useEffect(() => {
        AniContainer.create({
            triggerElement: '.d2x-detail-M .info-box',
            triggerHook: 1,
            offset: '20%',
            duration: '10%',
            onEnter: () => {
                setIsEnter(true);
            },
            isGpu: false,
        });
    }, []);

    return (
        <div
            className={`d2x-detail-M ${css.d2xDetailM} GtmModuleData-section`}
            id="d2x-detail-M"
            data-section-id={'d2x-detail-M'}
            data-section-title={t('sec13_title')}
        >
            <div className="text-box">
                <div className="title">{t('sec13_title')}</div>
                <div className="desc">
                    {t.rich('sec13_desc', {
                        line1: (text: any) => <span>{text}</span>,
                    })}
                </div>
            </div>
            <div className="img-box">
                <NextImage
                    webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z4.webp')}
                    src={require('@publicLocal/delta2max/teaser/pc/eu/z4.jpg')}
                    alt={t('sec4_title')}
                    aria-label={t('sec4_title')}
                />
            </div>
            <div className={`${isEnter ? 'isEnter' : ''} info-box`}>
                <div className="left">
                    <div>{t('sec13_delta2max')}</div>
                    <div>{t('sec13_others')}</div>
                </div>
                <div className="process-boxs">
                    <div className="process-box">
                        <div className="bar-box">
                            <div className="bar bar1">
                                <div className="process"></div>
                            </div>
                            <div className="text">{t('sec13_process1')}</div>
                        </div>
                        <div className="value-box">
                            <div className="value">{t('sec13_process1_value')}</div>
                            <div className="unit">{t('sec13_process1_desc')}</div>
                        </div>
                    </div>
                    <div className="process-box">
                        <div className="bar-box">
                            <div className="bar bar2">
                                <div className="process"></div>
                            </div>
                            <div className="text">{t('sec13_process2')}</div>
                        </div>
                        <div className="value-box">
                            <div className="value">{t('sec13_process2_value')}</div>
                            <div className="unit">{t('sec13_process2_desc')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
